module.exports = __webpack_public_path__ + "static/img/szafa_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_4.jpg
// module id = 63tl
// module chunks = 0